import { getAPIGatewayDataFromParent } from '../handler/ParentDataHandler';
import {getCurrentTime, getNodeId, getStationCode} from "../util/NetworkUtil";
import {logOperationalMetric, METRIC_PROCESS_NAME, METRIC_PROCESS_NAME_WITH_STATION_CODE} from "../util/MetricsUtil"

const APIGatewayLink = async ({url, method, body}) => {
    const request = {
        resourcePath: `/ndvs/ndvs/${url}`,
        httpMethod: method,
        processName: "depart",
        requestBody: body
    }

    const response = await getAPIGatewayDataFromParent(request);
    if (response.status === 200) {
        return {
            valid: true,
            data: response.data
        }
    } else {
        return {
            valid: false,
            data: {}
        };
    }
};

const endpoints = {
    GET_PACKAGES: "getTransferShipments",
    GET_DRIVERS: "getDrivers",
    PRINT_TRANSFER_SHEET: "printTransferSheet",
    PRINT_STORE_RECONCILIATION_SHEET: "printStoreReconciliationSheet",
    PRINT_DEPARTURE_SHEET: "printDepartureSheet",
    PRINT_LABEL_SHEET: "printLabelSheet",
    GET_FEATURE_STATUS: "getFeaturesStatus",
    VIRTUAL_DEPART_DRIVER: "virtualDepartDriver",
    GET_STATION_LEVEL_PACKAGE_SUMMARY: "getStationLevelPackageSummary",
    PRINT_DRIVER_PACKAGE_SUMMARY: "printDriverPackageSummary",
    GET_DRIVER_ASSIGNED_PACKAGE: "getDriverAssignedPackage",
    FETCH_ACTIVE_LMVRIDs: "fetchActiveLmVRIDsForStation",
    DOWNLOAD_EWAY_BILL: "fetchEwayBillForPackages",
    VIRTUAL_DEPART_STORE: "virtualDepartStore"
};

const CallAPI  = async (endpoint, httpVerb, args) => {
    const startTime = getCurrentTime();
    const response = await APIGatewayLink({
        url: endpoint,
        method: httpVerb,
        body: args
    });
    logOperationalMetric(startTime,
        METRIC_PROCESS_NAME,
        endpoint,
        response.valid);
    logOperationalMetric(startTime,
        METRIC_PROCESS_NAME_WITH_STATION_CODE,
        endpoint,
        response.valid);
    return response;
};

export const NDVSClient = {
    getFeaturesStatus: async (args) => {
        console.log("getFeaturesStatus", args);
        return await CallAPI(endpoints.GET_FEATURE_STATUS,
            "post",
            {...args, ...getStationCode()});
    },

    getExceptionShipments: async (args) => {
        console.log("getExceptionShipments", args);
        return await CallAPI(endpoints.GET_PACKAGES,
            "post",
            {...args, ...getStationCode()})
    },
    getDriversList: async (args) => {
        console.log("getDriversList", args);
        return await CallAPI(endpoints.GET_DRIVERS,
            "post",
            {...args, ...getStationCode()})
    },
    printTransferSheet: async (args) => {
        console.log("printTransferSheet", args);
        return await CallAPI(endpoints.PRINT_TRANSFER_SHEET,
            "post",
            {...args, ...getStationCode()})
    },
    printStoreReconciliationSheet: async (args) => {
        console.log("printStoreReconciliationSheet", args);
        return await CallAPI(endpoints.PRINT_STORE_RECONCILIATION_SHEET,
            "post",
            {...args, ...getStationCode()})
    },
    printDepartureSheet: async (args) => {
        console.log("printDepartureSheet", args);
        return await CallAPI(endpoints.PRINT_DEPARTURE_SHEET,
            "post",
            {...args, ...getStationCode()})
    },
    printLabelSheet: async (args) => {
        console.log("printLabelSheet", args);
        return await CallAPI(endpoints.PRINT_LABEL_SHEET,
            "post",
            {...args, ...getStationCode()})
    },
    virtualDepartDriver: async (args) => {
        console.log("virtualDepartDriver", args);
        return await CallAPI(endpoints.VIRTUAL_DEPART_DRIVER,
            "post",
            {...args, ...getStationCode()})
    },
    stationlevelPackageSummary: async (args) => {
        console.log("StationLevelPackageSummary", args);
        return await CallAPI(endpoints.GET_STATION_LEVEL_PACKAGE_SUMMARY,
            "post",
            {...args, ...getStationCode()})
    },
    driverAssignedTrackingIdList: async (args) => {
        console.log("DriverAssignedTrackingIdList", args);
        return await CallAPI(endpoints.GET_DRIVER_ASSIGNED_PACKAGE,
            "post",
            {...args})
    },
    printDriverPackageSummary: async (args) => {
        console.log("printDriverPackageSummary", args);
        return await CallAPI(endpoints.PRINT_DRIVER_PACKAGE_SUMMARY,
            "post",
            {...args, ...getStationCode()})
    },
    fetchActiveLmVRIDsForStation: async (args) => {
        console.log("fetchActiveLmVRIDsForStation", args);
        return await CallAPI(endpoints.FETCH_ACTIVE_LMVRIDs,
            "post",
            {...args, ...getNodeId()})
    },

    downloadEwayBill: async (args) => {
        console.log("Download EwayBill", args);
        return await CallAPI(endpoints.DOWNLOAD_EWAY_BILL,
            "post",
            {...args, ...getNodeId()})
    },

    virtualDepartStore: async (args) => {
        return await CallAPI(endpoints.VIRTUAL_DEPART_STORE,
            "post",
            {...args, ...getStationCode()})
    }

};


// WEBPACK FOOTER //
// ./src/components/client/NDVSClient.js